import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

/**
 * Suppression d'une tournée non démarrée (DELETE /tours/:tour_id).
 *
 * Selon le mode d'envoi en exploitation du client, la tournée redevient un
 * brouillon de « Affectations camion » ou est supprimée (ses commandes
 * reviennent « À placer »). deleteTour renvoie true si la suppression a été
 * acceptée ; un refus (tournée démarrée, importée…) est affiché tel quel.
 */
export default function useDeleteTour() {
  const [isLoading, setIsLoading] = useState(false);

  const deleteTour = async (tourId) => {
    try {
      setIsLoading(true);
      const response = await fleetApi.delete(`/tours/${tourId}`);
      toast.success(response?.data?.message || 'La tournée a été supprimée.');
      return true;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "La tournée n'a pas pu être supprimée. Veuillez réessayer."
      );
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, deleteTour };
}
